import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

interface ILastSearchState {
  fields: any;
}

const initialState: ILastSearchState = {
  fields: {}
};

const setSavedSearch = ( state: ILastSearchState, action: any ) => {
  return updateObject( state, { fields: action.fields } );
};

const reducer = ( state = initialState, action: any ) => {
    switch ( action.type ) {
        case actionTypes.LAST_SEARCH_SET: return setSavedSearch( state, action );
        default: return state;
    }
};

export default reducer;
